module.exports = __webpack_public_path__ + "static/media/background-2.c344b3cb.svg";